import React, { useMemo } from 'react';
import { Input, List, Select } from 'antd';
import type { Park, ParkLevelFilter } from '../../types';
import { countParksByLevel } from '../../utils/helpers';

interface ParkProfileSidebarProps {
  parks: Park[];
  keyword: string;
  level: ParkLevelFilter;
  onKeywordChange: (value: string) => void;
  onLevelChange: (value: ParkLevelFilter) => void;
  onOpenProfile: (parkId: string) => void;
}

export function ParkProfileSidebar(props: ParkProfileSidebarProps): React.ReactElement {
  const { parks, keyword, level, onKeywordChange, onLevelChange, onOpenProfile } = props;
  const statistics = useMemo(() => countParksByLevel(parks), [parks]);

  return (
    <aside className="dash-panel dash-panel--left">
      <div className="dash-section">
        <div className="dash-stat-grid">
          <div className="dash-stat-card">
            <div className="dash-stat-card__label">国家级园区数量</div>
            <div className="dash-stat-card__value">{statistics.national}</div>
          </div>
          <div className="dash-stat-card">
            <div className="dash-stat-card__label">省级园区数量</div>
            <div className="dash-stat-card__value dash-stat-card__value--accent">{statistics.provincial}</div>
          </div>
          <div className="dash-stat-card">
            <div className="dash-stat-card__label">待开发园区数量</div>
            <div className="dash-stat-card__value dash-stat-card__value--pending">{statistics.pending}</div>
          </div>
        </div>
      </div>
      <div className="dash-section">
        <div className="dash-field-label">园区名称</div>
        <Input allowClear value={keyword} placeholder="请输入园区名称" onChange={(event) => onKeywordChange(event.target.value)} />
        <div className="dash-field-label dash-field-label--spaced">园区等级</div>
        <Select
          className="dash-select"
          dropdownClassName="dash-select-dropdown"
          style={{ width: '100%' }}
          value={level}
          onChange={onLevelChange}
          options={[
            { label: '全部', value: 'all' },
            { label: '国家级', value: 'national' },
            { label: '省级', value: 'provincial' },
            { label: '待开发', value: 'pending' },
          ]}
        />
      </div>
      <div className="dash-section dash-section--grow">
        <div className="dash-field-label">专题园区列表（{parks.length}）</div>
        <div className="dash-list-wrap">
          <List
            size="small"
            dataSource={parks}
            locale={{ emptyText: '暂无符合条件的专题园区' }}
            renderItem={(park) => (
              <List.Item className="dash-list-item" onClick={() => onOpenProfile(park.id)}>
                <span className="dash-list-item__name">{park.name}</span>
                <span className="park-profile-sidebar__level">
                  {park.parkLevel === 'national' ? '国家级' : park.parkLevel === 'provincial' ? '省级' : '待开发'}
                </span>
              </List.Item>
            )}
          />
        </div>
      </div>
    </aside>
  );
}
